<template>
	<label :for="`datepicker-${name}`" class="bbox-datepicker-label" :class="{ 'has-error': !!error }">
		<span :class="[labelClassesToApply, 'label']" v-if="!$slots.label && !!label">{{ label }}</span>
		<slot name="label" />
		<div class="input-wrapper">
			<span class="icon-left" v-if="$slots['icon-left']"><slot name="icon-left"/></span>
			<span class="icon-right" v-if="$slots['icon-right']"><slot name="icon-right"/></span>
			<vue-datepicker
				:language="ptBR"
				:name="name"
				@change="$emit('change', $event)"
				@input="$emit('input', $event)"
				:value="value"
				:placeholder="placeholder"
				:input-class="inputClassesToApply"
			/>
			<!-- <datepicker ref="input" class="bbox-text-input" :input-class="[inputClassesToApply,{'has-icon-left': !!$slots['icon-left'], 'has-icon-right': !!$slots['icon-right']}]" :type="type" :id="`datepicker-${name}`" :value="value" :name="name" @change="($event) => {$emit('change', $event.target.value);}" @input="($event) => {$emit('input', $event.target.value);}" :placeholder="placeholder" /> -->
		</div>
		<span class="input-error font-size-big red-base margin-top-tiny" v-if="!!error"
			><b-icon><icon-error-outline /></b-icon> {{ error }}</span
		>
	</label>
</template>

<script>
import { ptBR } from 'vuejs-datepicker/dist/locale';
import VueDatepicker from 'vuejs-datepicker';
import BIcon from './Icon.vue';

export default {
	name: 'b-datepicker-other',
	data() {
		return {
			ptBR
		};
	},
	components: {
		VueDatepicker,
		BIcon
	},
	props: {
		inputClasses: {
			type: String,
			default:
				'font-size-big ink-base placeholder-ink-lighter-2 padding-normal border border-white-darker-4 border-focus-ink-lighter-1  bg-white-darker-2 bg-focus-white-darker-3'
		},
		inputErrorClasses: {
			type: String,
			default:
				'font-size-big red-base placeholder-red-lighter-2 padding-normal border border-red-lighter-2 border-focus-red-base  bg-red-lighter-4 bg-focus-red-lighter-3'
		},
		labelClasses: {
			type: String,
			default: 'font-size-big ink-base semi-bold margin-bottom-normal display-block'
		},
		labelErrorClasses: {
			type: String,
			default: 'font-size-big ink-base semi-bold margin-bottom-normal display-block'
		},
		name: {
			type: String,
			required: true
		},
		label: {
			type: String,
			default: ''
		},
		value: {
			type: Date,
			default: ''
		},
		placeholder: {
			type: String,
			default: 'Digite aqui...'
		},
		error: {
			type: String,
			default: ''
		}
	},
	computed: {
		inputClassesToApply() {
			if (this.error) return this.inputErrorClasses;
			else return this.inputClasses;
		},
		labelClassesToApply() {
			if (this.error) return this.labelErrorClasses;
			else return this.labelClasses;
		}
	}
};
</script>

<style lang="scss">
.bbox-datepicker-label .vc-container {
	--slide-translate: 22px;
	--slide-duration: 0.15s;
	--slide-timing: ease;
	--header-padding: 1rem 10px 0 10px;
	--title-padding: 0 8px;
	--arrows-padding: 10px;
	--arrow-font-size: 1.8rem;
	--weekday-padding: 0.5rem 0;
	--weeks-padding: 5px 5px 0px 5px;
	--arrow-horizontal-offset: 10px;
	--arrow-vertical-offset: 11px;
	--day-min-height: 1.9rem;
	--day-content-width: 3.1rem;
	--day-content-height: 3.1rem;
	--day-content-margin: 0.1rem auto;
	--day-content-transition-time: 0.13s ease-in;
	--day-content-bg-color-hover: rgba(204, 214, 224, 0.3);
	--day-content-dark-bg-color-hover: rgba(114, 129, 151, 0.3);
	--day-content-bg-color-focus: rgba(204, 214, 224, 0.4);
	--day-content-dark-bg-color-focus: rgba(114, 129, 151, 0.4);
	--highlight-height: 2.75rem;
	--dot-diameter: 5px;
	--dot-border-radius: 50%;
	--dot-spacing: 3px;
	--bar-height: 3px;
	--bars-width: 75%;
}
.bbox-datepicker-label .vc-bg-blue-600 {
	background-color: #365df0;
}
.bbox-datepicker-label .vc-text-sm {
	font-size: 1.5rem;
}
.bbox-datepicker-label .vc-text-md {
	font-size: 1.625rem;
}
.bbox-datepicker-label .vc-text-lg {
	font-size: 1.75rem;
}
.bbox-datepicker-label,
.bbox-datepicker-label * {
	box-sizing: border-box;
	font-family: 'Inter', sans-serif !important;
}
.bbox-datepicker-label {
	display: block;
}
.bbox-datepicker-label .input-wrapper {
	position: relative;
	width: 100%;
	display: inline-block; //to counter margin merging
	&.autosize {
		width: auto;
		display: inline-block;
		input {
			width: auto;
		}
	}
}
.bbox-datepicker-label input {
	border-radius: 5px;
	display: block;
	width: 100%;
	position: relative;
	z-index: 1;
	outline: none;
}
.bbox-datepicker-label span.icon-left {
	position: absolute;
	left: 1.3125rem;
	top: calc(0.8125rem + 0.05em);
	color: #8f8a9b;
	z-index: 2;
}
.bbox-datepicker-label span.icon-right {
	position: absolute;
	top: calc(0.8125rem + 0.05em);
	right: 1.3125rem;
	color: #8f8a9b;
	z-index: 2;
}
.bbox-datepicker-label input.has-icon-left {
	padding-left: calc(2.625rem + 0.8em);
}
.bbox-datepicker-label input.has-icon-right {
	padding-right: calc(2.625rem + 0.8em);
}
.bbox-datepicker-label span.input-error {
	display: block;
	text-align: left;
	line-height: 1.2;
}
.bbox-datepicker-label label span.label {
	display: block;
	text-align: left;
}
.bbox-datepicker-label .vc-text-sm {
	font-size: 1.6rem;
}
</style>

<docs>

#### Datepicker Input (Other)
OBS: Este componente foi criado para caso desistirmos do outro datepicker (que é mais fácil de utilizar mas mais difícil de customizar).
Este componente é baseado no componente de input padrão do DLS, e foi utilizado o vuejs-datepicker para mostrar o datepicker.

É necessário instalar `vuejs-datepicker` para usar este componente.

```js

<b-datepicker-other />

```

</docs>
